import React, { useState, useRef, useCallback } from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import { FaMap } from 'react-icons/fa';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure
} from '@chakra-ui/react';

const DEFAULT_LOCATION = { lat: 60.205091947890025, lng: 24.656152725219727 };

const MapPicker = (props: { onLocationChange(location: { lat: number; lng: number }): void }) => {
  const [selectedLocation, setSelectedLocation] = useState(DEFAULT_LOCATION);
  const [userHasSelected, setUserHasSelected] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  const handleMapClick = useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setSelectedLocation({ lat, lng });

    if (markerRef.current) {
      markerRef.current.setPosition({ lat, lng });
    } else {
      markerRef.current = new google.maps.Marker({
        position: { lat, lng },
        map: mapRef.current
      });
    }
  }, []);

  const renderMap = useCallback(
    (map) => {
      mapRef.current = map;
      map.addListener('click', handleMapClick);
    },
    [handleMapClick]
  );

  const handleSave = () => {
    onClose();
    setUserHasSelected(true);
    props.onLocationChange(selectedLocation);
  };

  return (
    <div>
      <Button leftIcon={<FaMap />} type="button" onClick={onOpen} colorScheme="blue" variant="outline" mr={3}>
        Valitse kartalta
      </Button>
      {userHasSelected && (
        <span style={{ marginLeft: '5px', fontStyle: 'italic' }}>
          ({selectedLocation.lat.toFixed(5)}, {selectedLocation.lng.toFixed(5)})
        </span>
      )}
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Valitse tapahtumapaikka kartalta</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Wrapper apiKey="AIzaSyBKq4aJTDitIcnLweaoVAPQk0loQgFyG2c">
              <div
                id="map"
                style={{ width: '100%', height: '400px' }}
                ref={(el) => {
                  if (el && !mapRef.current) {
                    const map = new google.maps.Map(el, {
                      center: selectedLocation || { lat: 0, lng: 0 },
                      zoom: 13
                    });
                    renderMap(map);
                  }
                }}
              />
            </Wrapper>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSave}>
              Tallenna
            </Button>
            <Button
              colorScheme="red"
              variant="ghost"
              onClick={() => {
                onClose();
                setSelectedLocation(DEFAULT_LOCATION);
                setUserHasSelected(false);
              }}
            >
              Nollaa
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default MapPicker;
